import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';

import ProductDetail from './ProductDetailPage';

const ToggleFavoriteMutation = gql`
  mutation toggleFavorite($variantId: String!) {
    toggleFavorite(variantId: $variantId)
  }
`;

export default compose(
  graphql<any, any>(ToggleFavoriteMutation, {
    name: 'toggleFavorite'
  })
)(ProductDetail);



// WEBPACK FOOTER //
// ./src/pages/ProductDetail/index.tsx